export { default } from './equationCell';
